import { CreationSearchParams, useSearchCreations } from "$/util/search";
import { ArrowOutwardRounded } from "@mui/icons-material";
import { Box, Button, Link } from "@mui/material";
import React from "react";
import CreationHorizontalList from "./CreationHorizontalList";

function CreationImageListWidget(props: { searchParams: CreationSearchParams }) {
  const { searchParams } = props;
  const { data: items } = useSearchCreations(searchParams || {});

  return (
    <>
      <CreationHorizontalList items={items} />

      <Box sx={{ textAlign: "right" }}>
        <Button
          component={Link}
          href={`/search?q=${searchParams.query}`}
          variant="text"
          color="inherit"
          endIcon={<ArrowOutwardRounded />}
          sx={{
            mt: 2,
          }}
        >
          More like this
        </Button>
      </Box>
    </>
  );
}

export default CreationImageListWidget;
